import { adminHttpClient } from '../commons/adminHttpClient'
import ProductTaskCommonIds from './productTaskCommonIds'
import { TaskStatus } from '../adminDashboard/adminTasks'

export type CompanyProductTaskDetailsResponse = {
  id: number
  name: string
  description: string
  icon: string
  priority: number
  status: TaskStatus
}

const getCompanyProductTaskDetails = async (id: ProductTaskCommonIds): Promise<CompanyProductTaskDetailsResponse> => {
  return await adminHttpClient.get(`/Tasks/CompanyProductTaskDetails/${id}`)
}

export default getCompanyProductTaskDetails
